module.exports = __webpack_public_path__ + "src/app/assets/images/speakers/sabin.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/speakers/sabin.jpg
// module id = 603
// module chunks = 0